(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumaro-drop-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('[data-lux-drop]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumaro-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function initAll() {
      document.querySelectorAll('.lumaro-hero:not([data-lux-init])').forEach(initHero);
    }

    function initHero(hero) {
      hero.setAttribute('data-lux-init', '');
      fitViewport(hero);
      spawnParticles(hero);
      if (reduced()) return;
      magnetize(hero);
      pointer(hero);
      whenGSAP(function (gsap) { entrance(hero, gsap); });
    }

    // Wait (briefly) for the global GSAP script to finish loading.
    function whenGSAP(cb) {
      if (window.gsap) return cb(window.gsap);
      var tries = 0;
      var t = setInterval(function () {
        if (window.gsap) { clearInterval(t); cb(window.gsap); }
        else if (++tries > 40) { clearInterval(t); } // ~4s: give up, CSS stays visible
      }, 100);
    }

    // Publish the real header-group height so the hero can size itself to the
    // actually-visible viewport. Observed rather than read once: the header
    // reflows on resize, and the announcement bar can be edited live.
    function fitViewport(hero) {
      var group = document.getElementById('header-group');
      if (!group) return;
      var write = function () {
        hero.style.setProperty('--lux-header', Math.round(group.getBoundingClientRect().height) + 'px');
      };
      write();
      if ('ResizeObserver' in window) new ResizeObserver(write).observe(group);
      else window.addEventListener('resize', write, { passive: true });
    }

    function spawnParticles(hero) {
      var host = hero.querySelector('[data-lux-particles]');
      if (!host || host.childElementCount) return;
      // Each particle is an independently animated element. Kept low on
      // purpose — past ~12 the cost is measurable and the effect is not.
      var n = window.innerWidth < 750 ? 6 : 12;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var p = document.createElement('span');
        p.className = 'lux-particle';
        var size = (Math.random() * 2 + 1).toFixed(1);
        p.style.left = (Math.random() * 100) + '%';
        p.style.top = (Math.random() * 100) + '%';
        p.style.width = p.style.height = size + 'px';
        p.style.setProperty('--p-op', (Math.random() * 0.4 + 0.25).toFixed(2));
        p.style.animationDuration = (Math.random() * 10 + 9) + 's';
        p.style.animationDelay = (-Math.random() * 16) + 's';
        frag.appendChild(p);
      }
      host.appendChild(frag);
    }

    // Entrance only — the permanent float is CSS, so it keeps running whether
    // or not GSAP ever arrives.
    function entrance(hero, gsap) {
      var items = hero.querySelectorAll('.lux-animate');
      if (!items.length) return;
      gsap.set(items, { opacity: 0, y: 26, filter: 'blur(6px)' });
      var caseEl = hero.querySelector('[data-lux-case]');
      if (caseEl) gsap.set(caseEl, { opacity: 0, y: 0, scale: 0.94, filter: 'blur(5px)' });

      var tl = gsap.timeline({ delay: 0.12, defaults: { ease: 'power3.out' } });
      tl.to(hero.querySelectorAll('[data-lux="eyebrow"], [data-lux="h1"]'), {
        opacity: 1, y: 0, filter: 'blur(0px)', duration: 1, stagger: 0.11
      });
      if (caseEl) {
        tl.to(caseEl, { opacity: 1, scale: 1, filter: 'blur(0px)', duration: 1.5, ease: 'power4.out' }, '-=1.0');
      }
      tl.to(hero.querySelectorAll('[data-lux="desc"], [data-lux="cta"], [data-lux="trust"]'), {
        opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.85, stagger: 0.1
      }, '-=1.1');
      tl.to(hero.querySelectorAll('[data-lux="badge"], [data-lux="finish"], [data-lux="scroll"]'), {
        opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.75, stagger: 0.12
      }, '-=0.8');
    }

    // One rAF-throttled pointer handler drives both the glow offset and the
    // glass-panel drift, all through CSS custom properties (no per-frame JS
    // style thrash, no GSAP dependency).
    function pointer(hero) {
      if (matchMedia('(hover: none)').matches) return;
      var panels = hero.querySelectorAll('[data-lux-tilt]');
      var nx = 0, ny = 0, queued = false;

      function apply() {
        queued = false;
        hero.style.setProperty('--lux-px', nx.toFixed(3));
        hero.style.setProperty('--lux-py', ny.toFixed(3));
        for (var i = 0; i < panels.length; i++) {
          var depth = 5 + i * 3; // px — deliberately tiny; luxury means calm
          panels[i].style.setProperty('--tx', (nx * depth).toFixed(2) + 'px');
          panels[i].style.setProperty('--ty', (ny * depth).toFixed(2) + 'px');
        }
      }

      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        nx = (e.clientX - r.left) / r.width - 0.5;
        ny = (e.clientY - r.top) / r.height - 0.5;
        if (!queued) { queued = true; requestAnimationFrame(apply); }
      }, { passive: true });

      hero.addEventListener('mouseleave', function () {
        nx = 0; ny = 0;
        if (!queued) { queued = true; requestAnimationFrame(apply); }
      });
    }

    function magnetize(hero) {
      if (matchMedia('(hover: none)').matches) return;
      hero.querySelectorAll('[data-lux-magnetic]').forEach(function (btn) {
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          btn.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5) * 10 + 'px');
          btn.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5) * 8 + 'px');
        }, { passive: true });
        btn.addEventListener('mouseleave', function () {
          btn.style.setProperty('--mx', '0px');
          btn.style.setProperty('--my', '0px');
        });
      });
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumaro-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-lux-story]');
    if (!root) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ── Particles: created here rather than in markup so the count can adapt
       to the viewport and the DOM stays clean. ── */
    var field = root.querySelector('[data-st-particles]');
    if (field && !reduce) {
      var count = window.innerWidth < 750 ? 18 : 38;
      var html = '';
      for (var i = 0; i < count; i++) {
        var left = Math.random() * 100;
        var top = 60 + Math.random() * 60;
        var dur = 9 + Math.random() * 14;
        var delay = -Math.random() * 20;
        var dx = (Math.random() - 0.5) * 90;
        var scale = 0.6 + Math.random() * 1.5;
        html +=
          '<span style="left:' + left.toFixed(2) + '%;top:' + top.toFixed(2) + '%;' +
          'animation-duration:' + dur.toFixed(2) + 's;animation-delay:' + delay.toFixed(2) + 's;' +
          '--dx:' + dx.toFixed(1) + 'px;transform:scale(' + scale.toFixed(2) + ');"></span>';
      }
      field.innerHTML = html;
    }

    /* ── Reveal on scroll ── */
    /* Reveals are deliberately NOT one-shot: the observer keeps watching, so
       an element that scrolls out of view returns to its starting state and
       animates again on the way back down. */
    var revealables = root.querySelectorAll('.st-rise, .st-step');
    if (!('IntersectionObserver' in window) || reduce) {
      for (var r = 0; r < revealables.length; r++) revealables[r].classList.add('is-in');
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-in', entry.isIntersecting);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      for (var k = 0; k < revealables.length; k++) io.observe(revealables[k]);
    }

    /* ── Count-up ── */
    var counters = root.querySelectorAll('[data-st-count]');

    function runCounter(el) {
      var target = parseInt(el.getAttribute('data-st-count'), 10) || 0;
      if (reduce) { el.textContent = target; return; }

      // Cancel a run still in flight, so scrolling in and out quickly can
      // never leave two loops fighting over the same element.
      if (el._stRaf) cancelAnimationFrame(el._stRaf);

      var duration = 1800;
      var startedAt = null;
      function tick(now) {
        if (startedAt === null) startedAt = now;
        var progress = Math.min((now - startedAt) / duration, 1);
        // ease-out cubic: fast start, settles on the number
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased);
        if (progress < 1) {
          el._stRaf = requestAnimationFrame(tick);
        } else {
          el._stRaf = null;
        }
      }
      el._stRaf = requestAnimationFrame(tick);
    }

    function resetCounter(el) {
      if (el._stRaf) cancelAnimationFrame(el._stRaf);
      el._stRaf = null;
      el.textContent = '0';
    }

    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) runCounter(entry.target);
          else resetCounter(entry.target);
        });
      }, { threshold: 0.4 });
      for (var c = 0; c < counters.length; c++) cio.observe(counters[c]);
    } else {
      for (var c2 = 0; c2 < counters.length; c2++) runCounter(counters[c2]);
    }

    if (reduce) return;

    /* ── Parallax + timeline progress, one shared rAF loop.
       Scroll handlers only flag work; all layout reads happen in the frame. ── */
    var parallaxEls = root.querySelectorAll('[data-st-parallax]');
    var timeline = root.querySelector('[data-st-timeline]');
    var progress = root.querySelector('[data-st-timeline-progress]');
    var queued = false;

    function frame() {
      queued = false;
      var vh = window.innerHeight;

      for (var p = 0; p < parallaxEls.length; p++) {
        var el = parallaxEls[p];
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) continue;
        var factor = parseFloat(el.getAttribute('data-st-parallax')) || 0.05;
        var offset = (rect.top + rect.height / 2 - vh / 2) * -factor;
        el.style.setProperty('--st-shift', offset.toFixed(1) + 'px');
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      }

      if (timeline && progress) {
        var trect = timeline.getBoundingClientRect();
        var span = trect.height + vh * 0.6;
        var passed = vh * 0.8 - trect.top;
        var pct = Math.max(0, Math.min(1, passed / span));
        progress.style.width = (pct * 100).toFixed(1) + '%';
      }
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(frame);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    /* ── Subtle tilt on images ── */
    /* Tilt. Pointer events only store the position; the transform is written
       once per frame, so a fast mouse cannot queue up dozens of style
       writes and layout thrash. */
    var tilts = root.querySelectorAll('[data-st-tilt]');
    for (var t = 0; t < tilts.length; t++) {
      (function (el) {
        var amount = el.classList.contains('st-craft__tile') ? 3.5 : 5;
        var pending = false;
        var px = 0;
        var py = 0;

        function apply() {
          pending = false;
          el.style.transform =
            'perspective(1000px) rotateY(' + (px * amount).toFixed(2) + 'deg) rotateX(' +
            (-py * amount).toFixed(2) + 'deg)';
        }

        el.addEventListener('mouseenter', function () {
          el.classList.add('is-tilting');
        });

        el.addEventListener('mousemove', function (event) {
          var rect = el.getBoundingClientRect();
          px = (event.clientX - rect.left) / rect.width - 0.5;
          py = (event.clientY - rect.top) / rect.height - 0.5;
          if (pending) return;
          pending = true;
          requestAnimationFrame(apply);
        });

        el.addEventListener('mouseleave', function () {
          // Drop the fast transition first so the reset uses the long ease.
          el.classList.remove('is-tilting');
          el.style.transform = '';
        });
      })(tilts[t]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumaro-withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-lux-withdrawal]');
    if (!root) return;

    var form = root.querySelector('form');
    var fields = root.querySelector('[data-lux-wd-fields]');
    var submit = root.querySelector('[data-lux-wd-submit]');
    var success = root.querySelector('[data-lux-wd-success]');
    var formError = root.querySelector('[data-lux-wd-form-error]');
    var honeypot = root.querySelector('input[name="contact[Firma]"]');

    if (!form || !fields || !submit) return;

    // Server already rendered the success state (no-JS fallback completed).
    if (success && !success.hidden) return;

    var required = Array.prototype.slice.call(form.querySelectorAll('[required]'));
    var sending = false;

    var MESSAGES = {
      missing: 'Bitte fülle dieses Feld aus.',
      email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      consent: 'Bitte bestätige den Widerruf, um fortzufahren.'
    };

    function errorNodeFor(field) {
      var id = field.getAttribute('aria-describedby');
      return id ? document.getElementById(id) : null;
    }

    function valueOk(field) {
      if (field.type === 'checkbox') return field.checked;
      var value = (field.value || '').trim();
      if (!value) return false;
      // The browser's own type=email parser, rather than a hand-rolled regex.
      if (field.type === 'email') return field.checkValidity() && value.indexOf('@') > 0;
      return true;
    }

    function messageFor(field) {
      if (field.type === 'checkbox') return MESSAGES.consent;
      if (!(field.value || '').trim()) return MESSAGES.missing;
      if (field.type === 'email') return MESSAGES.email;
      return MESSAGES.missing;
    }

    function showError(field, show) {
      var node = errorNodeFor(field);
      if (field.type !== 'checkbox') {
        field.setAttribute('aria-invalid', show ? 'true' : 'false');
      }
      if (!node) return;
      if (show) {
        node.textContent = messageFor(field);
        node.hidden = false;
      } else {
        node.hidden = true;
        node.textContent = '';
      }
    }

    function allValid() {
      for (var i = 0; i < required.length; i++) {
        if (!valueOk(required[i])) return false;
      }
      return true;
    }

    function refresh() {
      submit.disabled = sending || !allValid();
    }

    required.forEach(function (field) {
      field.addEventListener('input', function () {
        // Clear an error as soon as it is resolved, but never scold mid-typing.
        if (valueOk(field)) showError(field, false);
        refresh();
      });
      field.addEventListener('change', function () {
        showError(field, !valueOk(field));
        refresh();
      });
      field.addEventListener('blur', function () {
        if ((field.value || '').trim() || field.type === 'checkbox') {
          showError(field, !valueOk(field));
        }
      });
    });

    function firstInvalid() {
      for (var i = 0; i < required.length; i++) {
        if (!valueOk(required[i])) return required[i];
      }
      return null;
    }

    function setSending(state) {
      sending = state;
      submit.classList.toggle('is-sending', state);
      submit.disabled = state || !allValid();
      submit.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    function showSuccess() {
      fields.hidden = true;
      if (success) {
        success.hidden = false;
        success.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }


    form.addEventListener('submit', function (event) {
      if (sending) {
        event.preventDefault();
        return;
      }

      var invalid = firstInvalid();
      if (invalid) {
        event.preventDefault();
        required.forEach(function (field) { showError(field, !valueOk(field)); });
        invalid.focus();
        return;
      }

      // Silently accept and drop anything that filled the honeypot.
      if (honeypot && honeypot.value) {
        event.preventDefault();
        showSuccess();
        return;
      }

      var stamp = form.querySelector('[data-lux-wd-timestamp]');
      if (stamp) stamp.value = new Date().toLocaleString('de-DE');

      if (!window.fetch || !window.FormData) return; // native submit

      event.preventDefault();
      setSending(true);
      if (formError) formError.hidden = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed: ' + response.status);
          setSending(false);
          showSuccess();
        })
        .catch(function () {
          // Anything at all went wrong — hand the submission back to the
          // browser so it completes the normal way instead of being lost.
          setSending(false);
          form.submit();
        });
    });

    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
